import { SkyscannerRadarAlternativedatesV1AlternativeDates } from '@skyscanner-internal/radar-web-http-client';

import { grpcFetchClientWrapperNoHeaders } from '../internals/clients/grpc/grpc';

export const alternativeDatesRequest = grpcFetchClientWrapperNoHeaders(
  SkyscannerRadarAlternativedatesV1AlternativeDates.AlternativeDatesService.AlternativeDates,
  {
    pathPrefix: '/g/radar',
    clientName: 'RADAR_ALTERNATIVE_DATES',
    timeoutMs: 10_000,
  },
);
